import apiClient from './api.client';
import { API } from '../constants/api';
import type {
  VenuePublic,
  VenueAccess,
  VenueStaff,
  RegisterVenuePayload,
  UpdateVenuePayload,
} from '../types/venue.types';
import type { PublicEventDetail } from '../types/public_event.types';

export async function registerVenue(payload: RegisterVenuePayload): Promise<VenuePublic> {
  const res = await apiClient.post<{ data: VenuePublic }>(API.VENUE_REGISTER, payload);
  return res.data.data;
}

export async function getMyVenueAccess(): Promise<VenueAccess[]> {
  const res = await apiClient.get<{ data: VenueAccess[] }>(API.VENUE_MY_ACCESS);
  return res.data.data;
}

export async function getVenueById(id: string): Promise<VenuePublic> {
  const res = await apiClient.get<{ data: VenuePublic }>(API.VENUE_BY_ID(id));
  return res.data.data;
}

export async function updateVenue(id: string, payload: UpdateVenuePayload): Promise<VenuePublic> {
  const res = await apiClient.patch<{ data: VenuePublic }>(API.VENUE_BY_ID(id), payload);
  return res.data.data;
}

export async function getVenueStaff(venueId: string): Promise<VenueStaff[]> {
  const res = await apiClient.get<{ data: VenueStaff[] }>(API.VENUE_STAFF(venueId));
  return res.data.data;
}

export async function inviteStaff(venueId: string, email: string): Promise<VenueStaff> {
  const res = await apiClient.post<{ data: VenueStaff }>(API.VENUE_STAFF(venueId), { email });
  return res.data.data;
}

export async function removeStaff(venueId: string, userId: string): Promise<void> {
  await apiClient.delete(API.VENUE_STAFF_REMOVE(venueId, userId));
}

export async function getVenueEvents(venueId: string): Promise<PublicEventDetail[]> {
  const res = await apiClient.get<{ data: PublicEventDetail[] }>(`${API.VENUE_BY_ID(venueId)}/events`);
  return res.data.data;
}

export interface OrganizerNotice {
  id: string;
  publicEventId: string;
  organizerId: string;
  status: 'pending' | 'sanctioned' | 'disputed';
  createdAt: string;
  eventTitle?: string;
  organizerName?: string;
}

export async function getVenueNotices(venueId: string): Promise<OrganizerNotice[]> {
  const res = await apiClient.get<{ data: OrganizerNotice[] }>(API.VENUE_NOTICES(venueId));
  return res.data.data;
}

export async function respondToNotice(
  venueId: string,
  noticeId: string,
  action: 'sanction' | 'dispute',
): Promise<OrganizerNotice> {
  const res = await apiClient.post<{ data: OrganizerNotice }>(
    API.VENUE_NOTICE_RESPOND(venueId, noticeId),
    { action },
  );
  return res.data.data;
}
